import i18n from "i18n"
import { Table } from "antd"
import { TRIP_PRICE } from "../../utils/constants"
import { durationFormatter } from "utils/durationFormatter";

function cellRender(value) {
  if (value === null || value === undefined) return "-";
  return `$${value}`;
}

export const columns = [
  {
    title: i18n.t("experiences.scheduling.sections.length_and_rates.duration"),
    dataIndex: TRIP_PRICE.DURATION,
    key: TRIP_PRICE.BUFFER_TIME,
    render: durationFormatter
  },
  {
    title: i18n.t("experiences.scheduling.sections.length_and_rates.buffer_time"),
    dataIndex: TRIP_PRICE.BUFFER_TIME,
    key: TRIP_PRICE.BUFFER_TIME,
    render: durationFormatter
  },
  {
    title: i18n.t("experiences.scheduling.sections.length_and_rates.flat_rate"),
    dataIndex: TRIP_PRICE.FLAT_RATE,
    key: TRIP_PRICE.FLAT_RATE,
    render: cellRender
  },
  {
    title: i18n.t("experiences.scheduling.sections.length_and_rates.adults"),
    dataIndex: TRIP_PRICE.PRICE_ADULT,
    key: TRIP_PRICE.PRICE_ADULT,
    render: cellRender
  },
  {
    title: i18n.t("experiences.scheduling.sections.length_and_rates.children"),
    dataIndex: TRIP_PRICE.PRICE_CHILD,
    key: TRIP_PRICE.PRICE_CHILD,
    render: cellRender
  },
  {
    title: i18n.t("experiences.scheduling.sections.length_and_rates.infants"),
    dataIndex: TRIP_PRICE.PRICE_INFANT,
    key: TRIP_PRICE.PRICE_INFANT,
    render: cellRender
  },
  {
    title: i18n.t("experiences.scheduling.sections.length_and_rates.passengers"),
    dataIndex: TRIP_PRICE.PRICE_PASSENGER,
    key: TRIP_PRICE.PRICE_PASSENGER,
    render: cellRender
  },
  Table.EXPAND_COLUMN
];
